module.exports = __webpack_public_path__ + "static/media/icon_guest.cc95c2af.svg";